/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  passwordChangeFailed: 'passwordChangeFailed',
  passwordChangeSuccess: 'passwordChangeSuccess',
  passwordPolicyInformation: 'passwordPolicyInformation',
  minLength: 'minLength',
  maxLength: 'maxLength',
  excludeWhitespaces: 'excludeWhitespaces',
  minMatchingCharRules: 'minMatchingCharRules',
  minUppercaseChar: 'minUppercaseChar',
  minLowercaseChar: 'minLowercaseChar',
  minNumericChar: 'minNumericChar',
  minSpecialChar: 'minSpecialChar'
}; export default Keys;